enum PreferredPronouns {
    Unknown = 0,
    He = 1,
    She,
    They,
    Other
}

export { PreferredPronouns };
